// User
export const API_USER = "/user/getauthmatrix";
export const API_CREATE_NEW_USER_ROLE_GROUP = "/group/list/user";
export const API_NEW_GROUP_ROLES = "/group/list/groups";
export const API_NEW_USER_ROLES = "/roles";
export const API_GET_GROUP_LIST = "/group/list";
export const API_USER_LIST = "/user/list";
export const API_GET_GROUP_PERMISSION_LIST = "/permission/list";
export const API_CREATE_GROUP = "/group/creategroup";
export const API_EDIT_GROUP = "/group/editgroup";
export const API_TOGGLE_GROUP_ACTIVATION = "/group/toggleactivation";
export const API_CREATE_ADMIN_USER = "/user/create";
export const API_EDIT_ADMIN_USER = "/user/edit";
export const API_DEACTIVATE_ADMIN_USER = "/user/deactivate";
export const API_ACTIVATE_ADMIN_USER = "/user/activate";
export const API_RESEND_TEMPORARY_PASSWORD = "/user/resend-temporary-password";
export const API_GET_CONFIG_DATA = "/config/getdata";
export const API_UPDATE_WATCHWORD_RESET_LOG = "/user/updatepasswordresetlog";
export const API_GET_USER_REPORT = "/user/report";
export const API_GET_CARD_ENQUIRY_DETAILS = "/wrapper/cardenquiry";
export const API_GET_MEMBER_ENQUIRY_DETAILS = "/wrapper/memberenquiry";
export const API_DELINK_MEMBER = "/wrapper/delinkmember";
export const API_INSERT_AUDIT_LOG = "/auditlog/insert";
// Retro Claim
export const API_CREATE_RETRO_CLAIM = "/retroclaim/create";
export const API_REJECT_RETRO_CLAIM = "/retroclaim/reject";
export const API_EDIT_RETRO_CLAIM = "/retroclaim/edit";
export const API_REQUEST_RETRO_CLAIM = "/retroclaim/requestapproval";
export const API_APPROVE_RETRO_CLAIM = "/retroclaim/approve";
export const API_GET_RETRO_CLAIM_LIST = "/retroclaim/get";
export const API_GET_RETRO_CLAIM_PERMISSIONS = "/retroclaim/permissionflag";
export const API_GET_STORE_LIST = "/store/list";

// OFFERS
export const API_FETCH_ACTIVE_OFFERS = "/offers/getActiveOfferList";
export const API_FETCH_USER_OFFERS = "/offers/fetchUserOffer";
export const API_REDEEM_OFFERS = "/offers/redeemOffer";
export const API_BULK_OFFER_ISSUANCE = "/offers/bulkOfferDraft";
export const API_UPDATE_OFFER = "/offers/updateuseroffer";

export const API_BULK_OFFER_ISSUANCE_DRAFT_LIST = "/offers/bulkOfferDraftList";
export const API_BULK_OFFER_ISSUANCE_CHANGE_STATUS = "/offers/bulkOfferChangeStatus";
export const API_BULK_OFFER_ISSUANCE_DOWNLOAD = "/offers/bulkOffersDownloadReport";

// NON MEMBER ACCOUNT CREATION
export const API_GET_RESERVED_NON_MEMBER = "/cr-account/get-reserved-non-member";
export const API_CREATE_NON_MEMBER_USERS = "/cr-account/create-non-member-users";

// Reimbursement
export const API_REJECT_DECLARATION = "/reimbursement/rejectdeclaration";
export const API_ACCEPT_DECLARATION = "/reimbursement/acceptdeclaration";
export const API_GET_REIMB_SUMMARY_LIST = "/reimbursement/getsummary";
export const API_GET_REIMB_DETAILS = "/reimbursement/getdetails";
export const API_APPROVE_REIMBURSEMENT = "/reimbursement/approvereimbursement";
export const API_REIM_VERIFICATION_APPROVE_CLAIM = "/reimbursement/sendforapproval";

export const API_GET_ADMIN_REIMB_REJECTION_REP = "/reimbursement/getrejectiondata";
export const API_GET_ADMIN_REIMB_VOUCHER_REP = "/reimbursement/getvoucherreimbrep";
export const API_GET_VOUCHER_DETAILS_REP = "/reimbursement/getvoucherdetailsrep";
export const API_GET_TENANT_REIMB_SETTLEMENT_REP = "/reimbursement/getsettlementdata";
export const API_GET_TENANT_VOUCHER_REDEMPTION_REP = "/report/getvoucherredemptionreport";
export const API_GET_RETRO_CLAIM_REP = "/report/getretroclaimreport";
export const API_GET_ADHOC_ADMIN_REP = "/report/getreport";

// Merge CR Accounts
export const API_MERGE_CR_ACCOUNTS = "/cr-account/merge";

// Points Expiry Summary
export const API_CR_POINTS_EXPIRY_SUMMARY = "/cr-account/points-expiry-summary";

// Membership Status
export const API_CR_GET_MEMBERSHIP_STATUS = "/wrapper/cardenquiry";
export const API_CR_UPDATE_MEMBERSHIP_STATUS = "/cr-account/update-membership-status";

// Void CR Transaction
export const API_GET_CR_TRANSACTION = "/cr-transaction/get-transaction";
export const API_VOID_CR_TRANSACTION = "/wrapper/void-transaction";

// Outlet Management
export const API_CREATE_OUTLET = "/store/create-store";
export const API_GET_LAST_UPDATED_OUTLET_LIST = "/store/last-updated";
export const API_GET_OUTLET = "/store/search";
export const API_GET_TAGS = "/store/tags";
export const API_GET_CATEGORY_TYPE_3_TAGS = "/store/category-type-3";
